import "./styles.css"
import {useLocation, useNavigate} from "react-router-dom";
import {PATH_STRINGS} from "../../routes/route-props";
import {AtmosfairLogo, Text} from "atmosfair-ui"
import {useFusionAuth} from "@fusionauth/react-sdk";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {RED} from "../../styles/additional-colors";
import {useEffect, useState} from "react";
import {useAppSelector} from "../../redux/reducer/store";
import {Tooltip} from "@mui/material";
import KlimaLinkLogo from "../../molecules/logos/klima-link-logo/KlimaLinkLogo";
import {theme} from "../../styles/theme";
import {cleanPathName} from "../../utils/string/common";

const NAVIGATION = [
    {
        label: 'NAVIGATION.HOME',
        path: PATH_STRINGS.travelDatabase
    },
    {
        label: "NAVIGATION.TRAVEL_COMPONENTS",
        path: PATH_STRINGS.travelComponentsOverview
    },
    {
        label: "NAVIGATION.JOURNEY",
        path: PATH_STRINGS.journey
    },
    {
        label: 'NAVIGATION.SETTINGS',
        path: PATH_STRINGS.settings
    }
]

const Navigation = () => {
    const {agenciesLogos, agencies} = useAppSelector(state => state.user)
    const [agencyLogo, setAgencyLogo] = useState<string | null>(null)
    const [active, setActive] = useState(0)
    const {logout} = useFusionAuth();
    const navigate = useNavigate()
    const {t} = useTranslation()
    const location = useLocation()
    const {pathname} = location

    const _checkPathName = (path: string | undefined, valueToCheckFor: string) => {
        if (!path) return 0
        return path.split('/').some(segment => segment.includes(valueToCheckFor))
    };

    useEffect(() => {
        const cleanedPathName = cleanPathName(pathname)
        const navigationPaths = NAVIGATION.map(nav => nav.path)
        if (cleanedPathName.includes("settings")) {
            setActive(3)
        } else if (_checkPathName(cleanedPathName, 'journey')) {
            setActive(navigationPaths.indexOf(PATH_STRINGS.journey))
        } else if (_checkPathName(cleanedPathName, "travel-components")) {
            setActive(navigationPaths.indexOf(PATH_STRINGS.travelComponentsOverview))
        } else {
            setActive(0)
        }
    }, [pathname])

    useEffect(() => {
        if (agencies?.length === 1 && agenciesLogos) {
            const agenciesLogosKeys = Object.keys(agenciesLogos)
            if (agenciesLogosKeys.length === 1) { //TODO() Which logo to choose if there is more than one agency for the user (only the case for agency admin)
                setAgencyLogo(agenciesLogos[agenciesLogosKeys[0]].imageBlob)
            } else {
                setAgencyLogo(null)
            }
        }
    }, [agenciesLogos])

    return <nav className={"navigation-container"}>
        <div className={"navigation-klimalink-logo-wrapper"}>
            <KlimaLinkLogo alt={"KLIMALINK_LOGO"} size={"medium"} imageClasses={'navigation-klimalink-logo'}/>
            {(process.env.REACT_APP_INSTANCE === "stage" || process.env.REACT_APP_INSTANCE === "local") &&
                <Tooltip title={t("TOOLTIP.COMMON.BETA")}>
                    <div className={"navigation-beta-badge"}>
                        <Text weight={"bold"} color={"white"}>BETA</Text>
                    </div>
                </Tooltip>}
            <div>
                <Text
                    italic={true}
                    style={{marginBottom: theme.spacer.small / 2}}
                    variant={"subtitleLarge"}>GENERAL.POWERED_BY</Text>
                <AtmosfairLogo
                    alt={t("NAVIGATION.LOGO_ALT")}
                    style={{width: 80}}
                    size={"small"}
                    whichLogo={"only-logo"}/>
            </div>
        </div>
        <ul className={clsx("navigation-list", !agencyLogo && "navigation-list-no-logo")}>
            {NAVIGATION.map((menuPoint, index) => {
                const {path, label} = menuPoint
                return <li key={index}>
                    <Text
                        classes={clsx("navigation-link", active === index ? 'navigation-active' : 'navigation-inactive')}
                        onClick={() => navigate(path)}>
                        {label}
                    </Text>
                </li>
            })}
            <li>
                <Text
                    style={{color: RED}}
                    classes={clsx("navigation-link", "navigation-logout")}
                    onClick={logout}>Logout</Text>
            </li>
            {agencyLogo && <li>
                <div className={"navigation-company-logo-wrapper"}>
                    <img
                        className={"navigation-company-logo"}
                        src={agencyLogo}
                        alt={t("NAVIGATION.LOGO_ALT")}/>
                </div>
            </li>
            }
        </ul>
    </nav>
}

export default Navigation